const CACHE_KEY = 'tugg_roster_v7';
const CACHE_TTL_MS = 10 * 60 * 1000;

export function getCachedRoster() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;

    const { players, goalies, salaries, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > CACHE_TTL_MS) {
      sessionStorage.removeItem(CACHE_KEY);
      return null;
    }

    return { players, goalies, salaries };
  } catch {
    return null;
  }
}

export function setCachedRoster(players, goalies, salaries) {
  try {
    sessionStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ players, goalies, salaries, timestamp: Date.now() })
    );
  } catch {
    // sessionStorage may be unavailable or full
  }
}
